<div class="flex-column" [ngClass]="{ 'with-picture': type !== 'forCandidatePage' }">
  <span class="folder-name">
    {{ folder.name }}
  </span>

  <span class="folder-candidate-numbers" [ngClass]="{ small: type !== 'forCandidatePage' }">
    @if (folder.candidatesCount) {
      {{ folder.candidatesCount | numberWithSpaces }}
    } @else {
      0
    }

    {{ folder.candidatesCount | currentNumeric: 'PROFILE' | translate }}
  </span>
</div>
